export function getColorContrast(color: number[]) {
  const toRelativeChannel = (channel: number) => {
    const normalized = channel / 255;
    return normalized <= 0.03928
      ? normalized / 12.92
      : Math.pow((normalized + 0.055) / 1.055, 2.4);
  };

  const luminance =
    0.2126 * toRelativeChannel(color[0] ?? 0) +
    0.7152 * toRelativeChannel(color[1] ?? 0) +
    0.0722 * toRelativeChannel(color[2] ?? 0);

  const blackContrast = (luminance + 0.05) / 0.05;
  const whiteContrast = 1.05 / (luminance + 0.05);

  return {
    colorContrast: blackContrast >= whiteContrast ? 'black' : 'white',
    luminance,
  };
}
